import React, { useState } from 'react';
import QRious from 'qrious';
import '../styles/styles.css';

const AssetQRGenerator = () => {
  const [assetNumber, setAssetNumber] = useState('');
  const [subNumber, setSubNumber] = useState('0000');
  const [qrCode, setQrCode] = useState(null);

  // 드롭다운 옵션 생성 (0000 ~ 0100)
  const generateOptions = () => {
    const options = [];
    for (let i = 0; i <= 100; i++) {
      const value = i.toString().padStart(4, '0');
      options.push(
        <option key={value} value={value}>
          {value}
        </option>
      );
    }
    return options;
  };

  // 숫자만 입력 제한
  const handleAssetNumberChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, '');
    if (value.length <= 8) {
      setAssetNumber(value);
    }
  };

  // QR 코드 생성
  const generateQRCode = () => {
    if (!assetNumber) {
      alert('자산번호를 입력해주세요.');
      return;
    }

    if (assetNumber.length < 8) {
      alert('자산번호는 8자리를 입력해주세요.');
      return;
    }

    try {
      const qrData = `LTWO_${assetNumber}_${subNumber}`;
      const canvas = document.createElement('canvas');
      
      const qr = new QRious({
        element: canvas,
        value: qrData,
        size: 280,
        background: 'white',
        foreground: '#202124',
        level: 'M'
      });

      setQrCode(canvas.toDataURL());
    } catch (error) {
      console.error('QR 코드 생성 실패:', error);
      alert('QR 코드 생성 중 오류가 발생했습니다.');
    }
  };

  // 엔터키 처리
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      generateQRCode();
    }
  };

  return (
    <div className="distribution-board-container">
      {/* 입력 폼 */}
      <div className="filter-container bg-white shadow-md rounded-lg p-4 mb-4">
        <h3 className="text-lg font-semibold mb-4">자산관리 QR 코드 생성</h3>
        
        <div>
          {/* 자산번호 입력 */}
          <div>
            <div className="flex items-center justify-between mb-2">
              <label className="text-sm font-medium text-gray-700">
                자산번호
              </label>
              <span className="text-sm text-gray-500 font-medium">
                {assetNumber.length}/8자리
              </span>
            </div>
            <input
              type="text"
              value={assetNumber}
              onChange={handleAssetNumberChange}
              onKeyPress={handleKeyPress}
              placeholder="숫자 8자리 입력"
              maxLength="8"
              className="w-full p-3 border border-gray-300 rounded-lg text-center font-mono text-lg tracking-wider focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
            />
          </div>

          {/* 자산하위번호 선택 */}
          <div className="mt-8">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              자산하위번호
            </label>
            <select
              value={subNumber}
              onChange={(e) => setSubNumber(e.target.value)}
              className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
            >
              {generateOptions()}
            </select>
          </div>

          {/* 생성 버튼 */}
          <div className="mt-8">
            <button
              onClick={generateQRCode}
              disabled={!assetNumber || assetNumber.length < 8}
              className="w-full bg-blue-500 text-white py-4 px-6 rounded-lg font-medium text-lg hover:bg-blue-600 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors shadow-sm"
            >
              QR 코드 생성
            </button>
          </div>
        </div>
      </div>

      {/* QR 코드 결과 */}
      {qrCode && (
        <div className="bg-white shadow-md rounded-lg p-6">
          <div className="flex justify-center">
            <div className="bg-gray-50 p-6 rounded-lg inline-block">
              <img 
                src={qrCode} 
                alt="Generated QR Code" 
                className="block mx-auto"
                style={{ imageRendering: 'pixelated' }}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AssetQRGenerator;